import React from "react";
import AppModal from "../common/AppModal";
import UpdateBranchSettingsForm from "../../forms/UpdateBranchSettingsForm";
import { BranchSettingsResponseDto } from "../../shared/dtos/branchSettings/BranchSettingsResponseDto";

interface UpdateBranchSettingsModalProps {
  open: boolean;
  onClose: () => void;
  branchSettings: BranchSettingsResponseDto | null;
  loading: boolean;
  error?: string | null;
}

const UpdateBranchSettingsModal: React.FC<UpdateBranchSettingsModalProps> = ({
  open,
  onClose,
  branchSettings,
  loading,
  error = null,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title="Edit Branch Settings"
    width="md"
    loading={loading}
  >
    <UpdateBranchSettingsForm
      branchSettings={branchSettings}
      loading={loading}
      error={error}
    />
  </AppModal>
);

export default UpdateBranchSettingsModal;
